function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { validateError } from '@/services/services';
import tasks from '@/js/tasks';
import axios from 'axios';
import setupInterceptors from '@/services/setupInterceptors';
var configuration = JSON.parse(process.env.VUE_APP_API_GTW_CONFIG);
//console.log(configuration)
// declare service gtw
var appApisGTW = null;
if (!configuration['visualization']) {
  appApisGTW = axios.create({
    baseURL: 'http://localhost{PORT}'.replace('{PORT}', ':8091')
  });
} else {
  appApisGTW = axios.create({
    baseURL: process.env.VUE_APP_API_GTW.replace('{PORT}', ':8091')
  });
}
setupInterceptors(appApisGTW);
var loginObj = function loginObj() {
  return {
    email: window.userInfo.email,
    tokenId: window.userInfo.accessToken,
    localId: window.userInfo.localId
  };
};
var CONTROLLER_NAME = '/powerbi';
var DOMAIN_REPORTS = '/reports';
var headers = {
  headers: {
    'Content-Type': 'application/json'
  }
};
export default {
  getReports: function getReports(data) {
    var _this = this;
    var login = loginObj();
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post(CONTROLLER_NAME + DOMAIN_REPORTS + '/get_all', body, headers).then(function (res) {
      tasks.lockScreen.unlock();
      return res.data;
    }).catch(function (err) {
      var message = '(getReports) Listar accesos de un usuario.';
      return validateError(err, message, function () {
        return _this.getReports(data);
      });
    });
  },
  assignOperatorReport: function assignOperatorReport(data) {
    var _this2 = this;
    var login = loginObj();
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post(CONTROLLER_NAME + DOMAIN_REPORTS + '/get_all', body, headers).then(function (res) {
      tasks.lockScreen.unlock();
      return res.data;
    }).catch(function (err) {
      var message = '(getReports) Listar accesos de un usuario.';
      return validateError(err, message, function () {
        return _this2.assignOperatorReport(data);
      });
    });
  },
  getReportById: function getReportById(data) {
    var _this3 = this;
    var login = loginObj();
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post(CONTROLLER_NAME + DOMAIN_REPORTS + '/get', body, headers).then(function (res) {
      tasks.lockScreen.unlock();
      return res.data;
    }).catch(function (err) {
      var message = '(getReports) Listar accesos de un usuario.';
      return validateError(err, message, function () {
        return _this3.getReportById(data);
      });
    });
  },
  reportInitWorkFlow: function reportInitWorkFlow(data) {
    var login = loginObj();
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post(CONTROLLER_NAME + DOMAIN_REPORTS + '/init_workflow', body, headers).then(function (res) {
      tasks.lockScreen.unlock();
      return res.data;
    }).catch(function (err) {
      var message = '(reportInitWorkFlow) Listar accesos de un usuario.';
      return validateError(err, message, function () {// this.reportInitWorkFlow(data)
      });
    });
  },
  reportSendAssignment: function reportSendAssignment(data) {
    var login = loginObj();
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post(CONTROLLER_NAME + DOMAIN_REPORTS + '/send_assigment', body, headers).then(function (res) {
      tasks.lockScreen.unlock();
      return res.data;
    }).catch(function (err) {
      var message = '(reportSendAssignment) Listar accesos de un usuario.';
      return validateError(err, message, function () {// this.reportSendAssignment(data)
      });
    });
  },
  massiveApprove: function massiveApprove() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var login = loginObj();
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post("".concat(CONTROLLER_NAME).concat(DOMAIN_REPORTS, "/massive_approve"), body).then(function (response) {
      return response.data;
    }).finally(function () {
      tasks.lockScreen.unlock();
    });
  },
  reportAddUpdate: function reportAddUpdate(data) {
    var login = loginObj();
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post(CONTROLLER_NAME + DOMAIN_REPORTS + '/add_update', body, headers).then(function (res) {
      tasks.lockScreen.unlock();
      return res.data;
    }).catch(function (err) {
      var message = '(reportAddUpdate) Listar accesos de un usuario.';
      return validateError(err, message, function () {// this.reportAddUpdate(data)
      });
    });
  },
  reportLogQuery: function reportLogQuery(data) {
    var login = loginObj();
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post(CONTROLLER_NAME + DOMAIN_REPORTS + '/log_query', body, headers).then(function (res) {
      tasks.lockScreen.unlock();
      return res.data;
    }).catch(function (err) {
      var message = '(reportLogQuery) Listar accesos de un usuario.';
      return validateError(err, message, function () {// this.reportLogQuery(data)
      });
    });
  },
  reportPendingApproval: function reportPendingApproval(data) {
    var login = loginObj();
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post(CONTROLLER_NAME + DOMAIN_REPORTS + '/pending_approval', body, headers).then(function (res) {
      tasks.lockScreen.unlock();
      return res.data;
    }).catch(function (err) {
      var message = '(reportPendingApproval) Listar accesos de un usuario.';
      return validateError(err, message, function () {// this.reportPendingApproval(data)
      });
    });
  },
  reportQuery: function reportQuery(data) {
    var login = loginObj();
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post(CONTROLLER_NAME + DOMAIN_REPORTS + '/query', body, headers).then(function (res) {
      tasks.lockScreen.unlock();
      return res.data;
    }).catch(function (err) {
      var message = '(datasetAddUpdate) Listar accesos de un usuario.';
      return validateError(err, message, function () {// this.reportQuery(data)
      });
    });
  },
  reportQueryAllDomain: function reportQueryAllDomain(data) {
    var login = loginObj();
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post(CONTROLLER_NAME + DOMAIN_REPORTS + '/query_all_domain', body, headers).then(function (res) {
      tasks.lockScreen.unlock();
      return res.data;
    }).catch(function (err) {
      var message = '(reportQueryAllDomain) Listar accesos de un usuario.';
      return validateError(err, message, function () {// this.reportQueryAllDomain(data)
      });
    });
  },
  reportSetPermission: function reportSetPermission(data) {
    var login = loginObj();
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post(CONTROLLER_NAME + DOMAIN_REPORTS + '/set_permission', body, headers).then(function (res) {
      tasks.lockScreen.unlock();
      return res.data;
    }).catch(function (err) {
      var message = '(reportSetPermission) Listar accesos de un usuario.';
      return validateError(err, message, function () {// this.reportSetPermission(data)
      });
    });
  },
  setTemporalDataOperator: function setTemporalDataOperator(data) {
    var login = loginObj();
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post(CONTROLLER_NAME + DOMAIN_REPORTS + '/set_temporal_data_operator', body, headers).then(function (res) {
      tasks.lockScreen.unlock();
      return res.data;
    }).catch(function (err) {
      var message = '(datasetQueryAllDomain) Listar accesos de un usuario.';
      return validateError(err, message, function () {// this.setTemporalDataOperator(data)
      });
    });
  },
  filterBusinessTerm: function filterBusinessTerm(data) {
    var login = loginObj();
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post(CONTROLLER_NAME + DOMAIN_REPORTS + '/filter_business_term', body, headers).then(function (res) {
      tasks.lockScreen.unlock();
      return res.data;
    }).catch(function (err) {
      var message = '(datasetQueryAllDomain) Listar accesos de un usuario.';
      return validateError(err, message, function () {// this.filterBusinessTerm(data)
      });
    });
  },
  deletePermissionWorkspace: function deletePermissionWorkspace(data) {
    var login = loginObj();
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post(CONTROLLER_NAME + DOMAIN_REPORTS + '/delete_permission_workpsace', body, headers).then(function (res) {
      tasks.lockScreen.unlock();
      return res.data;
    }).catch(function (err) {
      var message = '(datasetQueryAllDomain) Listar accesos de un usuario.';
      return validateError(err, message, function () {// this.filterBusinessTerm(data)
      });
    });
  }
};